module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM14 23a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14zm8 0a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/pause-1.js
// module id = 1335
// module chunks = 14